var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState, useLayoutEffect } from "react";
import { addCommas, addCommasWithoutDecimal, } from "@domains/utils/numberMethods";
import _ from "underscore";
export var StreamValType;
(function (StreamValType) {
    StreamValType["EMPTY"] = "empty-val";
    StreamValType["RED"] = "change-red";
    StreamValType["GREEN"] = "change-green";
})(StreamValType || (StreamValType = {}));
var ReportValue = function (props) {
    var _a = __read(useState(props === null || props === void 0 ? void 0 : props.val), 2), val = _a[0], setVal = _a[1];
    var _b = __read(useState(), 2), streamClass = _b[0], setStreamClass = _b[1];
    useLayoutEffect(function () {
        var newVal = String(props === null || props === void 0 ? void 0 : props.val);
        if (!props.valueIsSummarized) {
            if (props.hideDecimal === true)
                newVal = addCommasWithoutDecimal(props === null || props === void 0 ? void 0 : props.val, props === null || props === void 0 ? void 0 : props.showZero, "", props === null || props === void 0 ? void 0 : props.maximumFractionDigits);
            else
                newVal = addCommas(props === null || props === void 0 ? void 0 : props.val, props === null || props === void 0 ? void 0 : props.showZero, "", props === null || props === void 0 ? void 0 : props.maximumFractionDigits);
        }
        if (newVal === "-" || (Math === null || Math === void 0 ? void 0 : Math.ceil(Math === null || Math === void 0 ? void 0 : Math.abs(parseFloat(newVal)))) === 0) {
            setStreamClass(StreamValType.EMPTY);
            setVal(props.showNA ? (React.createElement("div", { className: "".concat((props === null || props === void 0 ? void 0 : props.showNAclassName)
                    ? props === null || props === void 0 ? void 0 : props.showNAclassName
                    : "DMSans_16_500 txt_blackOne") }, "NA")) : (newVal));
        }
        else {
            if (newVal === null || newVal === void 0 ? void 0 : newVal.toString().includes("-")) {
                setStreamClass(StreamValType.RED);
            }
            else {
                setStreamClass(StreamValType.GREEN);
            }
            setVal(newVal);
        }
    }, [props.val, props.showNA, props.valueIsSummarized]);
    if (props.stream) {
        return (React.createElement("span", { className: "".concat(props.parentClass, " ").concat(streamClass), title: props.title },
            props.percentage && val !== "-" && !props.notRoundBracket && "(",
            props.suffix && props.suffix,
            !props.issuffixhide
                ? streamClass === StreamValType.GREEN
                    ? "+"
                    : ""
                : streamClass === StreamValType.GREEN && "",
            props.defaultReturn && streamClass === StreamValType.EMPTY
                ? props.defaultReturn
                : val,
            props.percentage && streamClass !== StreamValType.EMPTY && "%",
            val !== "-" && props.percentage && !props.notRoundBracket && ")",
            props.prefix && props.prefix));
    }
    else if (props.onlyval)
        return (React.createElement(React.Fragment, null,
            props.suffix && props.suffix,
            props.defaultReturn && streamClass === StreamValType.EMPTY
                ? props.defaultReturn
                : val,
            props.prefix && props.prefix));
    else
        return (React.createElement("span", { className: props.parentClass, title: props.title }, val));
};
export default React.memo(ReportValue, function (prevProps, NextProps) {
    return _.isEqual(prevProps, NextProps);
});
